import axios from "axios";
import Config from "../../config";
const config=new Config();
const defaultAuthorization=process.env.REACT_APP_default_Authorization

const axiosDefClient=axios.create({
    baseURL: `${config.BASEURL}`,
    responseType: "json",
    headers: {
        'Content-Type': 'application/json'
    }
});

export default axiosDefClient;